import { Flex, Typography } from "antd";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { IActivityLog, IService2 } from "../../../../util/varibles/interface";
import SiteDisease from "../../../Operation/FishDisease/SiteDisease";
import ServiceInfo from "../../../Popup/PopupOpInfo/Info/Service/ServiceInfo";
import WeatherSection from "../WeatherSection";

export default function Start({ log }: { log: IActivityLog }) {
    const [op] = useTrackingOp(state => state.op?.operation);

    if (!op) return <></>;

    const { real_start_time } = log;
    return <div className="w-full">
        <Flex gap={6}>
            <Typography.Text type="secondary">Start: </Typography.Text>
            <Typography.Text>{real_start_time ? datetime(real_start_time).format("HH:mm, DD/MM") : ""}</Typography.Text>
        </Flex>
        {(op?.diseases && op?.diseases.length > 0) && <SiteDisease diseases={op?.diseases} />}
        <div className="mt-[5px]">
            <ServiceInfo operation={op as IService2} />
        </div>
        <div className="w-full flex flex-col mt-5 items-center">
            <Typography.Title level={4} className="!mb-0">Weather Info.</Typography.Title>
            <Typography.Text className="!mb-3 block">(The weather chart will be live updated following the operation time, duration)</Typography.Text>
            <WeatherSection />
        </div>
    </div>
}